export enum Icon {
  calendar = 'calendar',
  calendarColored = 'calendarColored',
}
